import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import DetailsLayout from '@/components/layouts/DetailsLayout';
import { useUserContext } from '@/modules/auth/hooks/useUser';
import QuizDetailsHero from '@/modules/corporate/modules/quiz/views/QuizDetails/components/QuizDetailsHero';
import QuizDetailsProvider from '@/modules/corporate/modules/quiz/views/QuizDetails/context/QuizDetailsContext';
import getQuizDetailsSections from '@/modules/corporate/modules/quiz/views/QuizDetails/utils/getSections';

import CourseQuizPlayerHeader from '../../../CourseQuizPlayerHeader';
import { QuizPreviewType } from './types';

const PopupQuizPreview = (props: QuizPreviewType) => {
  const { courseId, quiz, popupQuizData, quizPerformance } = props;
  const { showModal, showQuizPlayer, onOpen, onClose, quizPlayerProps, reviewAttemptId, ...rest } =
    popupQuizData;
  const { t } = useTranslation();
  const user = useUserContext();

  return (
    <>
      <CourseQuizPlayerHeader content={quiz} onClose={onClose} />
      <QuizDetailsProvider
        {...rest}
        languageType={quiz?.languageType ?? undefined}
        userId={user.id}
        onBackToHome={onClose}>
        <DetailsLayout
          hero={
            <QuizDetailsHero
              isEmbed
              content={quiz}
              learnerId={user.id}
              parentEntityId={courseId}
              quizPerformance={quizPerformance}
            />
          }
          sections={getQuizDetailsSections({ content: quiz, t, quizPerformance })}
        />
      </QuizDetailsProvider>
    </>
  );
};

export default PopupQuizPreview;
